import Lock from '@material-ui/icons/Lock';
import { Button } from '../Button/NewButton';

interface Props {
  error: boolean;
  loading: boolean;
  onClose(): void;
  formValues: any;
}

export const PasswordFormButtons = ({
  error,
  loading,
  onClose,
  formValues,
}: Props) => (
  <div className="flex flex-row flex-grow items-center justify-between gap-2">
    <Button onClick={onClose}>Cancel</Button>
    <Button
      theme="action"
      startIcon={<Lock />}
      disabled={
        loading ||
        !formValues.currentPassword.length ||
        !formValues.newPassword.length ||
        !formValues.newConfirm.length ||
        error
      }
      type="submit"
    >
      Change Password
    </Button>
  </div>
);
